import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Husselavond zonder vrijwilligers</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Husselavond organiseren zonder vrijwilligers — kan dat?</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Vrijwilligerstekorten raken bijna iedere tennisvereniging. De gemiddelde leeftijd van actieve vrijwilligers stijgt, en de "vaste husselaar die alles regelt" wordt zeldzamer. <strong>Kun je een husselavond draaien zonder vrijwilliger?</strong> Het antwoord is verrassend simpel: ja, met de juiste tool.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat doet een husselaar normaal?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li>Spelers welkom heten en aanmelden registreren.</li><li>Per ronde een indeling maken op niveau.</li><li>Roepen wie naar welke baan moet.</li><li>Bijhouden wie net heeft gerust.</li><li>Aan het einde napraten in de kantine.</li></ol><p>Punt 1 t/m 4 kost wekelijks 2–3 uur en vereist iemand met overzicht én sociale vaardigheden. Dat is veel gevraagd.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat kan een app ervan overnemen?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Vrijwel alles, behalve punt 5 (de napraat-borrel — daar blijven mensen voor nodig). Concreet:</p><ul class="list-disc pl-6 space-y-1"><li><strong>Aanmelden</strong>: leden registreren zichzelf vooraf via hun telefoon.</li><li><strong>Indelen</strong>: het algoritme maakt iedere ronde een eerlijke verdeling op niveau, gespeelde rondes en cooldown.</li><li><strong>Communiceren</strong>: push-meldingen vertellen elke speler waar hij/zij moet spelen.</li><li><strong>Bijhouden</strong>: speeltijd en historie staan automatisch in het systeem.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat moet de club nog wel zelf doen?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li>Banen reserveren (eenmalig per seizoen).</li><li>De sessie aanmaken in de app (1 minuut werk).</li><li>Iemand bij de kantine voor drank en gezelligheid.</li></ol><p>Dat is alles. De rest verloopt zelfstandig.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Risico's en zorgen</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Sceptici zeggen vaak: "maar wie regelt het als iets misgaat?" Het antwoord: er gaat zelden iets mis. Push-meldingen, een live aanwezigheidslijst en een eenvoudige "afgelasting" knop dekken 95% van de scenario's. Voor onverwachte situaties (blessure, ruzie) is een aanwezig bestuurslid voldoende — die hoeft de avond niet te leiden.</p></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Praktijkvoorbeeld</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Een middelgrote tennisvereniging in Noord-Brabant draaide jarenlang met een vaste husselaar. Toen die wegviel, dreigde de wekelijkse husselavond te verdwijnen. Sinds ze De Hussel App gebruiken, draait de avond elke dinsdag zonder vaste vrijwilliger — alleen een bestuurslid loopt rond voor de gezelligheid. Opkomst is met 15% gestegen, omdat leden zich nu ook last-minute kunnen aanmelden.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Werkt dit echt zonder vrijwilliger?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. Honderden clubs draaien hun husselavond inmiddels zonder vaste husselaar. Wel handig: één bestuurslid aanwezig voor de gezelligheid.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">En als spelers vragen hebben tijdens de avond?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">De app toont voor iedere speler zijn baan en partners. Onduidelijkheden zijn zeldzaam.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoeveel tijd bespaart dit?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Gemiddeld 2–3 uur per week voor de vaste husselaar, plus de tijd die het kost om een vervanger te vinden bij ziekte.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Is dit niet onpersoonlijk?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Integendeel. Doordat de organisatie automatisch loopt, blijft er meer tijd over voor het sociale deel — koffie, drankje, napraten. Daar gaat het tenslotte om.</div>
    </details></div>
    </div>
  </section>`;

const BlogZonderVrijwilligers = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default BlogZonderVrijwilligers;
